<template>
    <div style="margin-top:20px;">
      <v-row>
        <v-col cols="12" sm="12" md="9" lg="9" xl="9" justify="center" align="center" style="padding-top:0;">
          <v-file-input density="compact" ref="file"
            show-size
            v-model="file_vcf"
            :label="upload_text"
            v-on:change="select($event)"
            style=""
            >
          </v-file-input>
        </v-col>

      <v-col cols="12" sm="12" md="3" lg="3" xl="3" justify="center" align="center" style="padding-left:0;padding-top:0;padding-bottom:0;padding-right:20px;margin-bottom:0;">
          <v-select @update:modelValue="updateRefGenome" v-model="refgen.id" :items="ref_genomes" label="Reference genome"
            item-title="name" item-value="id" solo
            density="compact"
            style="padding:0;margin:0;"
          >
          </v-select>
      </v-col>
      </v-row>
      <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12" justify="center" align="center">
            <div style="margin:auto;" class="">
              <v-btn color="#ffffff" style="" rounded="lg" elevation="2" @click="show_upload_info = !show_upload_info" v-bind="props">
                 <v-icon color="grey" icon="mdi-tooltip-question-outline"></v-icon>
                 <span style="padding-left:5px;">Info</span>
              </v-btn>
              <v-btn color="info" @click="selectFile()">
                 Upload
              </v-btn>

                      <v-dialog v-model="show_upload_info" style="">
                            <v-card style="padding:10px;">
                            Onkopus is able to process the following file formats:
                            <v-list>
                                <v-list-item>
                                    <div style="height:40px;">
                                        1) .vcf variant files (Download <v-btn color="info" @click="this.downloadSample('vcf')">sample.vcf</v-btn>)
                                    </div>
                                </v-list-item>
                                <v-list-item>
                                    <div style="height:40px;">
                                        2) .maf (Download <v-btn color="info" @click="this.downloadSample('maf')">sample.maf</v-btn>)
                                    </div>
                                </v-list-item>
                                <v-list-item>
                                    <div style="height:80px;">
                                        3) table-formatted data (.csv, .tsv, .xlsx, .txt)
                                        (Download <v-btn color="info" @click="this.downloadSample('csv')">sample.csv</v-btn>)
                                        (See the documentation for further details on input data formats)
                                    </div>
                                </v-list-item>
                            </v-list>
                            </v-card>
                      </v-dialog>
              <div style="text-align:left;font-size:14px;margin-top:5px;" class="font-weight-light"></div>


            </div>
         </v-col>
      </v-row>
    </div>
</template>

<script>
import UploadFilesService from "@/services/UploadFilesService";
import IDService from "@/services/IDService"
import 'vue-loading-overlay/dist/css/index.css';
import axios from 'axios';

export default {
  name: "upload-files",
  components: {
  },
  data() {
    return {
        currentFile: undefined,
        progress: 0,
        message: "",
        fileInfos: [],
        file:'',
        dataID:'',
        new_id:'',
        isLoading: false,
        fullPage: false,
        active_annot: true,
        refgen: { id:"hg38", name:"hg38 / GRCh38" },
        ref_genomes: [
                {
                    id: "hg38",
                    name: "hg38 / GRCh38"
                },
                {
                    id: "hg19",
                    name: "hg19 / GRCh37"
                },
                {
                    id: "t2t",
                    name: "T2T-CHM13"
                }
            ],
        show_upload_info: false,
        upload_text: "Upload variant file (.vcf, .maf, .csv, .tsv, .xlsx, .txt)",
        file_vcf: null,
    };
  },
  methods: {
    downloadSample(type) {
        let url = this.$store.getters.getPathVariable("methods_get_sample_file") + "?type=" + type
        let filename = "sample." + type

        //UploadFilesService.getFile(url)
        axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                     var fileLink = document.createElement('a');

                     fileLink.href = fileURL;
                     fileLink.setAttribute('download', filename);
                     document.body.appendChild(fileLink);

                     fileLink.click();
                });
    },
    updateRefGenome(val) {
        if (val == "hg38") {
            this.refgen = this.ref_genomes[0]
        } else if (val == "hg19") {
            this.refgen = this.ref_genomes[1]
        } else if (val == "t2t") {
            this.refgen = this.ref_genomes[2]
        }

        this.$store.dispatch('setGenomeVersion', val)
    },
    async selectTumorType(val) {
        this.$store.dispatch('setSelectedTumorType',val)
    },
    async select(file) {
        this.$store.dispatch("setFile",file.target.files[0])
    },
    async selectFile() {

      this.progress = 0;

      // clear all previous request results
      this.$store.dispatch("setVariants", {})
      this.$store.dispatch('setProcessState', [  "load-results",'<table><tr><td><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></td></tr><tr><td>Loading...</td></tr></table>' ] )
      this.$store.dispatch('clearAGG');

      await this.uploadFile(this.$store.getters.getGenomeVersion)

      // perform analysis
      this.$store.dispatch('setProcessState', [  "load-results",'<table><tr><td><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></td></tr><tr><td>Loading...</td></tr></table>' ] )

      this.$store.dispatch('setProcessState', [  "load-genompos",'<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>' ] )
      this.$store.dispatch('setProcessState', [  "load-gene-name",'<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>' ] )
      this.$store.dispatch('setProcessState', [  "load-variant-exchange",'<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>' ] )
      this.$store.dispatch('setProcessState', [  "load-dbsnp",'<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>' ] )
      this.$store.dispatch('setProcessState', [  "load-clinvar",'<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>' ] )
      this.$store.dispatch('setProcessState', [  "load-revel",'<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>' ] )
      this.$store.dispatch('setProcessState', [  "load-loftool",'<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>' ] )
      this.$store.dispatch('setProcessState', [  "load-vusp",'<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>' ] )
      this.$store.dispatch('setProcessState', [  "load-interpretations",'<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>' ] )

      let active_annotation = ""

      if (!this.active_annot) {
        active_annotation = '?annotate=0'
      }

      this.$store.dispatch('clearAGG');
      this.$router.push(this.$store.getters.getRouterBaseURL + '/upload/show-variant-interpretation-results/'+this.$store.getters.getIDData + active_annotation
        + "?genome_version=" + this.$store.getters.getGenomeVersion)

      //this.$store.dispatch('setProcessState',['load-results',''])

    },
    async uploadFile(refgen) {

      this.$store.dispatch('clearAGG');
      this.isLoading = true;
                setTimeout(() => {
                this.isLoading = false
            }, 120000)

      const file = this.$store.getters.getFile
      if (!file) {
        console.log("No file selected")
        return;
      }

      // generate temporary user ID if none is given
      let url = this.$store.getters.getPathVariable("methods_generate_new_id")

      let newid = await IDService.generateNewID((event) => {
                  this.progress = Math.round((100 * event.loaded) / event.total);
              }, 'pub', url)
      console.log("new id generated: "+newid.data)
      this.$store.dispatch('setIdData', newid.data)

      this.$store.dispatch('setSNVs', {})
      this.$store.dispatch('setIns', {})
      this.$store.dispatch('setDels', {})
      this.$store.dispatch('setCNVs', {})
      this.$store.dispatch('setFusions', {})

      this.message = ""
      url = this.$store.getters.getPathVariable( "methods_upload_vcf" )

      await UploadFilesService.upload(file, this.onProgress, this.$store.getters.getIDData, url, refgen, this.$store.getters.selectedTumorType)
        .then((response) => {
          this.message = response.data;
          this.new_id = response.data
          //var variant_data = response.data["data"]
          //var request_id = response.data["header"]["requestID"]
          //this.$store.dispatch("setRequestID", request_id)

          this.isLoading=false

          return response.data;
        })
        .catch(() => {
          this.progress = 0;
          this.message = "Could not upload the file!";
          this.currentFile = undefined;
          alert('error uploading file')
        });

    },
  },
  created() {
    this.file_vcf = this.$store.getters.getFile;
  }, 
  mounted() {
    if (this.$route.query.genome_version) {
        this.updateRefGenome(this.$route.query.genome_version)
    }
  }
};
</script>
